export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,
  /**
   * Obtener el model + datos de pasos 1 y 2
   */
  getConsulta: state => () => state.consulta,
  getMerlin: state => () => state.merlin,
  getPaso1: state => () => state.paso1,
  getPaso2: state => () => state.paso2,
  getPaso1Hogar: state => () => state.paso1Hogar,
  getPaso3Hogar: state => () => state.paso3Hogar,
  getPaso4Hogar: state => () => state.paso4Hogar,
  getCoberturas: state => () => state.cotizacionHogar.coberturasHogar,
  getCotizacion: state => () => state.cotizacionHogar,
  getTiposDeVivienda: state => () => state.tiposDeVivienda,
  getCoberturasAnadidas: state => () => state.coberturasAnadidas,
  getCoberturasSeleccionadas: state => () => state.coberturasSeleccionadas,
  getCelularNormalizado: state => () => state.celularNormalizado
};
